import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { Constants } from 'core';

import { createProductCode, createdProductCode, deleteProductCode, deletedProductCode } from './actions';
import { fetchProductCodes } from '../product-codes/actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';
import { sagaWithCallback } from '../utils';

type CreateProductCodeActionPayload = ReturnType<typeof createProductCode>;
type DeleteProductCodeActionPayload = ReturnType<typeof deleteProductCode>;

export function* createProductCodeSaga({ payload }: CreateProductCodeActionPayload) {
  const { createProductCodeApi } = getAPI();
  const response: YieldOf<typeof createProductCodeApi> = yield call(createProductCodeApi, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchProductCodes());
    yield put(createdProductCode(data));
    return data;
  } else {
    const error =
      status === Constants.ALREADY_EXISTED_STATUS ? Constants.ALREADY_EXISTED_PROBLEM_CODE : problem || 'unknown';
    yield put(createdProductCode(undefined, error));
    throw new Error('create product code failed: ' + error);
  }
}

export function* deleteProductCodeSaga({ meta: { id } }: DeleteProductCodeActionPayload) {
  const { deleteProductCodeApi } = getAPI();
  const response: YieldOf<typeof deleteProductCodeApi> = yield call(deleteProductCodeApi, id);
  const { ok, problem, status, data } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchProductCodes());
    yield put(deletedProductCode(true));
  } else {
    const error = data || problem || 'unknown';
    yield put(deletedProductCode(false, error));
  }
}

export default function* ProductCodeSaga() {
  yield takeLatest(createProductCode.type, sagaWithCallback(createProductCodeSaga));
  yield takeLatest(deleteProductCode.type, deleteProductCodeSaga);
}
